import { z } from 'zod';

export const settlementsSearchSchema = z.object({
  tab: z.enum(['statements', 'withdrawals']).default('statements').catch('statements'),
  page: z.coerce.number().int().min(1).default(1).catch(1),
});

export type SettlementsSearch = z.infer<typeof settlementsSearchSchema>;
